import React from 'react';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import { COLLAPSED_NAVBAR_HEIGHT } from 'styles/globals';
import PoweredBy5app from 'components/PoweredBy5app';
import { SkipNavigationLink, SkipNavigationTarget } from 'components/SkipNavigationLink';
import GlobalModals from './modals/globalModals';
import Navigation, { PageWrapper } from './navigation/Navigation';
import AssetViewer from './assetViewer';
import AlertRenderer from './alertRenderer';
import FloatingContactButton from './FloatingContactButton';
import WebAppInstallPrompt from './webAppInstallPrompt';
import HubErrorBoundary from '../pages/errors/HubErrorBoundary';
import { useAuthContext } from '../contexts/auth';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Page(_ref) {
  var children = _ref.children;
  var _useAuthContext = useAuthContext(),
    authUser = _useAuthContext.authUser;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (!authUser) {
    return null;
  }
  return /*#__PURE__*/_jsx(PageWrapper, {
    children: /*#__PURE__*/_jsxs(HubErrorBoundary, {
      children: [/*#__PURE__*/_jsx(SkipNavigationLink, {
        children: t('actions_skip_navigation')
      }), /*#__PURE__*/_jsx(Navigation, {}), /*#__PURE__*/_jsx(SkipNavigationTarget, {
        verticalOffset: COLLAPSED_NAVBAR_HEIGHT
      }), /*#__PURE__*/_jsx(AssetViewer, {}), /*#__PURE__*/_jsxs("main", {
        children: [children, config.floatingContactButton && /*#__PURE__*/_jsx(FloatingContactButton, {})]
      }), /*#__PURE__*/_jsx(GlobalModals, {}), /*#__PURE__*/_jsx(PoweredBy5app, {}), /*#__PURE__*/_jsx(WebAppInstallPrompt, {}), /*#__PURE__*/_jsx(AlertRenderer, {})]
    })
  });
}
export default Page;